import { Injectable } from '@angular/core';

import { CustomerCreationResponse } from '../../../../model/create-customer.model';
import { RetailCrmCreateAccountResponse } from '../../model/responses/create-account.model';

@Injectable({
  providedIn: 'root',
})
export class RetailCrmCreateAccountViewModelMapper {
  public mapCreateAccountResponse(createAccountResponse: RetailCrmCreateAccountResponse): CustomerCreationResponse {
    return { success: createAccountResponse.success, accountNumber: createAccountResponse.accountNumber };
  }
}
